// Kimliğe bürünme oturumlarının okuma/bitirme çağrıları. Oturumlar sayfası ve
// üst bant aynı uçları aynı sorgu anahtarıyla okur; bitirme ikisini birlikte
// tazeler.

import { unwrap } from "@/api/envelope";
import { operatorGraph } from "@/api/operator-graph";
import type { paths } from "@/api/types.gen";

export type ActiveImpersonationsQuery = NonNullable<
  paths["/ops/v1/impersonations/active"]["get"]["parameters"]["query"]
>;
export type ActiveImpersonationsData = NonNullable<
  paths["/ops/v1/impersonations/active"]["get"]["responses"][200]["content"]["application/json"]["data"]
>;
type EndImpersonationData = NonNullable<
  paths["/ops/v1/impersonations/{id}/end"]["post"]["responses"][200]["content"]["application/json"]["data"]
>;

export const IMPERSONATIONS_QUERY_KEY = ["operator", "impersonations"] as const;

export function activeImpersonationsQueryKey(includeAll: boolean) {
  return [...IMPERSONATIONS_QUERY_KEY, { includeAll }] as const;
}

export async function fetchActiveImpersonations(
  query: ActiveImpersonationsQuery,
): Promise<ActiveImpersonationsData> {
  return unwrap(operatorGraph.GET("/ops/v1/impersonations/active", { params: { query } }));
}

export interface EndImpersonationInput {
  readonly sessionId: string;
  /** Caller-owned immutable intent: retained only for an unchanged retry. */
  readonly idempotencyKey: string;
}

export async function endImpersonation(
  input: EndImpersonationInput,
): Promise<EndImpersonationData> {
  return unwrap(
    operatorGraph.POST("/ops/v1/impersonations/{id}/end", {
      params: {
        path: { id: input.sessionId },
        header: { "x-idempotency-key": input.idempotencyKey },
      },
    }),
  );
}
